<input type="text" class="date-picker" #inputRef>
<i class="fas fa-calendar-alt date-picker-icon"></i>